<template>
  <div>
<b-container>
<h1 class="p-color">Daniel Ruginets</h1>
        <h4><span class="p-color heading-padding">(he/him)</span></h4>
    <h2 class="">🧘‍ Empathetic Product Designer, 🌱 Environmentalist, and 🎙 Podcast Host. </h2>
    <h2>Currently at <a target="_blank" class="link2" href="https://www.linkedin.com/in/daniel-george-ruginets/">IBM</a></h2>
    <!-- <h2>📍 Based in Toronto. 🛩 Free to travel anywhere.</h2> -->
</b-container>
<b-container>
  <b-row>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <router-link to="/glide#">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Glide - Project Manager & UI/UX Designer" :img-src="glide" img-alt="Image of an iPhone with the logo of Glide on it." img-top>
                <p class="card-text">
      Glide is a task-based daily scheduling application for employees with ASD and their managers.
                </p>
          </b-card>
          </router-link>
    </b-col>

        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <router-link to="/fashionforchange#">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Fashion for Change - Volunteer" :img-src="fashionForChange" img-alt="Image of two macbook pros floating with the Fashion For Change Home Page embedded on them." img-top>
                <p class="card-text">
      Website re-design for Fashion For Change. Worked on this as a volunteer.
    </p>
          </b-card>
          </router-link>
    </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <router-link to="/snapsuite#">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="SnapSuite Inc - Internship" :img-src="snapsuite" img-alt="Image of a macbook pro with the home page of an app I designed for SnapSuite." img-top>
                <p class="card-text">
      Customer portal for companies to create work orders. From concept to final working product.
    </p>
          </b-card>
          </router-link>
    </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <router-link to="/cluep">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Cluep - UI/UX Designer" :img-src="cluep" img-alt="Work in progress imagenp" img-top>
                <p class="card-text">
      Building products and launching features as the only designer. In progress.
                </p>
          </b-card>
          </router-link>
    </b-col>
  </b-row>
</b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cluep: './../../static/images/homePage/cluep.png',
      fashionForChange: './../../static/images/homePage/FashionForChange.jpg',
      snapsuite: './../../static/images/homePage/snapsuite.jpg',
      glide: './../../static/images/homePage/GlideMockups2.png'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Righteous");

h1 {
  font-family: "Righteous", cursive;
  font-size: 100px;
}
h2{
  font-size:27px;
    padding-top: 15px;
  padding-bottom:15px;
}
.topmargin{
  padding-top:100px;
}
.no-margin {
  padding-left: 0px;
  padding-right: 0px;
}
.link {
  color: #000000;
  text-decoration: underline;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    font-weight: 600;
    font-size:20px !important;
}
.link:hover {
  background-size: 100% 100%;
  color: #000000;
}

.link2 {
  color: #000000;
  text-decoration: underline;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    font-weight: 600;
      font-size:27px;
    padding-top: 15px;
  padding-bottom:15px;
}
.link2:hover {
  background-size: 100% 100%;
  color: #000000;
}
.card-text {
  color:black;
}
.margin-on-card {
  margin-bottom: 20px;
  margin-top: 20px;
}

.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.general-padding{
  padding: 10px;
}
.card-size{
  width:100%;
}
.middle-margin{
  padding-left: 160px;
  padding-right: 160px;
}
.heading-padding{
  padding-top:40px;
  padding-bottom:10px;
}

/* On screens that are 992px or less, set the background color to blue */
@media screen and (max-width: 992px) {
h1{
    font-size: 100px;
}
  .middle-margin{
  padding-left: 40px;
  padding-right: 40px;
}
h2{
  font-size:23px;
  padding-top: 15px;
  padding-bottom:15px;
}
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
h1{
    font-size: 60px;
}
h2{
  font-size:21px;
  padding-top: 10px;
  padding-bottom:10px;
}
h4{
  font-size: 20px;
}
.heading-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.link{
      font-size:16px !important;
}
}

@media screen and (max-width: 400px) {
h1{
    font-size: 63px;
}
.heading-padding{
  padding-left:5px;
  padding-right:5px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.link{
      font-size:14px !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue